<header class="private-toolbar flex items-center justify-between">
  <div class="toolbar-left flex items-center gap-3 min-w-0 flex-1">
    <!-- Mobile burger -->
    <button class="burger-btn" id="private-toolbar-toggle-button" (click)="toggleMobileSidebar()"
      [appTippy]="TOOLTIP_KEYS.TOGGLE_SIDEBAR | translate" [tippyOptions]="{ placement: 'bottom' }">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="3" y1="6"  x2="21" y2="6"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
    </button>

    <!-- Breadcrumb -->
    <nav id="private-toolbar-breadcrumb" class="breadcrumb flex items-center gap-1 flex-nowrap overflow-hidden" aria-label="breadcrumb">
      @for (crumb of breadcrumbs(); track crumb.url; let last = $last, i = $index) {
        @if (!last) {
          <!-- breadcrumb-parent-link: alvo do passo de clique "voltar para a lista" dos tutoriais -->
          <a [routerLink]="crumb.url" class="breadcrumb-item" [class.breadcrumb-parent-link]="i === breadcrumbs().length - 2">
            {{ crumb.labelKey | translate }}
          </a>
          <span class="breadcrumb-sep">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </span>
        } @else {
          <span class="breadcrumb-item breadcrumb-active">
            {{ crumb.labelKey | translate }}
          </span>
        }
      }
    </nav>
  </div>

  <div class="toolbar-right flex items-center gap-2 shrink-0">
    <!-- Language dropdown -->
    <div class="lang-wrapper">
      <button class="icon-btn lang-btn lang-btn-desktop" id="private-toolbar-language-dropdown-button" (click)="toggleLanguageDropdown($event)"
        [appTippy]="TOOLTIP_KEYS.LANGUAGE | translate" [tippyOptions]="{ placement: 'bottom' }">
        <span class="lang-flag">{{ getCurrentLangOption().flag }}</span>
        <span class="lang-code">{{ currentLang() | uppercase }}</span>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          [class.chevron-open]="languageDropdownOpen">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      @if (languageDropdownOpen) {
        <div class="dropdown lang-dropdown">
          @for (lang of availableLangs; track lang.code) {
            <button class="dropdown-item" [id]="'private-toolbar-language-option-' + lang.code"
              [class.active]="currentLang() === lang.code"
              (click)="changeLanguage(lang.code)">
              {{ lang.flag }} {{ lang.label }}
            </button>
          }
        </div>
      }

      <label class="sr-only" for="private-toolbar-language-select">{{ 'language.label' | translate }}</label>
      <select
        id="private-toolbar-language-select"
        class="lang-select-mobile"
        [value]="currentLang()"
        (change)="onLanguageSelectChange($event)"
      >
        @for (lang of availableLangs; track lang.code) {
          <option [value]="lang.code" [selected]="currentLang() === lang.code">{{ lang.flag }} {{ lang.label }}</option>
        }
      </select>
    </div>

    <!-- Theme toggle -->
    <button class="icon-btn icon-btn--circle" (click)="toggleTheme()" id="private-toolbar-theme-button"
      [appTippy]="(isDark() ? TOOLTIP_KEYS.THEME_LIGHT : TOOLTIP_KEYS.THEME_DARK) | translate" [tippyOptions]="{ placement: 'bottom' }">
      @if (isDark()) {
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" id="private-toolbar-light-theme-icon">
          <circle cx="12" cy="12" r="4"/>
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
        </svg>
      } @else {
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" id="private-toolbar-dark-theme-icon">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
        </svg>
      }
    </button>

    <!-- Notifications bell -->
    <div class="notif-wrapper">
      <button
        id="private-toolbar-notifications-button"
        class="icon-btn icon-btn--circle notif-btn"
        (click)="toggleNotifDropdown($event)"
        [appTippy]="TOOLTIP_KEYS.NOTIFICATIONS | translate"
        [tippyOptions]="{ placement: 'bottom' }"
      >
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        @if (chatNotificationStore.hasUnread()) {
          <span id="private-toolbar-notifications-badge" class="notif-bell-badge">
            {{ chatNotificationStore.totalUnread() > 99 ? '99+' : chatNotificationStore.totalUnread() }}
          </span>
        }
      </button>

      @if (notifDropdownOpen) {
        <div id="private-toolbar-notifications-dropdown" class="dropdown notif-dropdown">
          <div class="notif-dropdown-header flex items-center justify-between px-3 py-2">
            <span class="notif-dropdown-title">{{ 'chat_notifications.title' | translate }}</span>
            @if (chatNotificationStore.hasUnread()) {
              <span class="notif-total-badge">{{ chatNotificationStore.totalUnread() }}</span>
            }
          </div>

          <div class="dropdown-divider"></div>

          @if (!chatNotificationStore.hasUnread()) {
            <p id="private-toolbar-notifications-empty" class="notif-empty">{{ 'chat_notifications.empty' | translate }}</p>
          } @else {
            @for (group of chatNotificationStore.notificationGroups(); track group.offerId || group.counterpartName) {
              <button
                type="button"
                class="dropdown-item notif-item"
                [id]="'private-toolbar-notification-item-' + (group.offerId || 'unknown')"
                (click)="navigateToOfferFromNotif(group)"
              >
                <span class="notif-item-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                </span>
                <div class="notif-item-body flex flex-col gap-0">
                  <span class="notif-item-name">{{ group.counterpartName || ('chat_notifications.unknown_company' | translate) }}</span>
                  @if (group.offerNumber) {
                    <span class="notif-item-offer">{{ 'chat_notifications.offer_label' | translate }} #{{ group.offerNumber }}</span>
                  }
                </div>
                <span class="notif-item-count">{{ group.totalUnread }}</span>
              </button>
            }
          }
        </div>
      }
    </div>

    <!-- User avatar + dropdown -->
    <div class="user-wrapper">
      <button class="user-btn" (click)="toggleUserDropdown($event)" id="private-toolbar-user-button" [appTippy]="getUserName()" [tippyOptions]="{ placement: 'bottom' }">
        @if (currentUser()?.image) {
          <img class="user-avatar-img" [src]="getUserAvatarUrl()" alt="{{ getUserName() }}" />
        } @else {
          <span class="user-avatar">{{ getUserInitial() }}</span>
        }
        <span class="user-email">{{ getUserEmail() }}</span>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          [class.chevron-open]="userDropdownOpen">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      @if (userDropdownOpen) {
        <div class="dropdown user-dropdown">
          <div class="user-dropdown-header">
            @if (currentUser()?.image) {
              <img class="user-dropdown-avatar-img" [src]="getUserAvatarUrl()" alt="{{ getUserName() }}" />
            } @else {
              <span class="user-dropdown-avatar">{{ getUserInitial() }}</span>
            }
            <div class="user-dropdown-info">
              <span class="user-dropdown-name">{{ getUserName() }}</span>
              <span class="user-dropdown-email">{{ getUserEmail() }}</span>
            </div>
          </div>

          <div class="dropdown-divider"></div>

          <button class="dropdown-item" (click)="goToProfile()" id="private-toolbar-profile-button">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            {{ 'private.toolbar.profile' | translate }}
          </button>

          <div class="dropdown-divider"></div>

          <button class="dropdown-item dropdown-item-logout" (click)="logout()" id="private-toolbar-logout-button">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            {{ 'private.toolbar.logout' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</header>
